import { render, staticRenderFns } from "./FormProductDeptsComponent.vue?vue&type=template&id=67228e7b&scoped=true"
import script from "./FormProductDeptsComponent.vue?vue&type=script&lang=js"
export * from "./FormProductDeptsComponent.vue?vue&type=script&lang=js"
import style0 from "./FormProductDeptsComponent.vue?vue&type=style&index=0&id=67228e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67228e7b",
  null
  
)

export default component.exports